import { SISTER_SEARCHER_PERFORMANCE_LEGEND } from "../constants/sister-searcher.constants";

// Preserves the PBIP indicator key without guessing the unavailable classification formula.
// Rows remain unclassified until the backend can provide the original report's indicator result.
const SisterSearcherPerformanceLegend = () => (
  <div className="flex flex-wrap gap-1.5" data-test="sister-searcher-performance-legend">
    {SISTER_SEARCHER_PERFORMANCE_LEGEND.map((item) => (
      <span
        key={item.label}
        className="rounded px-2 py-1 text-[10px] font-semibold"
        style={{ backgroundColor: item.background, color: item.text }}
      >
        {item.label}
      </span>
    ))}
  </div>
);

export default SisterSearcherPerformanceLegend;
